import React from 'react';
import PropTypes from 'prop-types';
import { StyledButton, StyledIcon } from './styled';
import { StyledButtonLink } from '../IconButton/styled';

const Button = ({ children, disabled, type, variant, startIcon, endIcon, fullWidth, to, size, customStyle, onClick }) => {
  return (
    <StyledButton
      as={!!to ? 'div' : 'button'}
      to={to}
      disabled={disabled}
      type={type}
      variant={variant}
      fullWidth={fullWidth}
      customStyle={customStyle}
      size={size}
      onClick={onClick}
    >
      {
        !!to &&
        <StyledButtonLink
          to={to}
        />
      }
      {startIcon && <StyledIcon position='start'>{startIcon}</StyledIcon>}
      {children}
      {endIcon && <StyledIcon position='end'>{endIcon}</StyledIcon>}
    </StyledButton>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
  variant: PropTypes.oneOf(['contained', 'text']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  fullWidth: PropTypes.bool,
  customStyle: PropTypes.array,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
};

Button.defaultProps = {
  disabled: false,
  type: 'button',
  variant: 'contained',
  fullWidth: false,
  size: 'medium',
  onClick: undefined,
};

export default React.memo(Button);
